import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Popup, Button, Input } from 'semantic-ui-react'
import v4 from 'uuid/v4'
import { isChaptersMode } from 'utils/functions'

const TEMPLATE_EMPTY = 'empty'
const TEMPLATE_CHAPTER = 'chapter'
const options = [
  {text: 'Пустой', value: TEMPLATE_EMPTY},
  {text: 'Глава', value: TEMPLATE_CHAPTER}
]

function getMetaTemplate (templateName) {
  let template

  switch (templateName) {
    case TEMPLATE_CHAPTER:
      template = {action: 'chapter', title: 'Название главы'}
      break
    case TEMPLATE_EMPTY:
    default:
      template = {action: 'new event'}
  }

  return template
}

class MetaAddForm extends Component {
  constructor () {
    super(...arguments)

    this.state = {
      dts: '',
      template: isChaptersMode() ? TEMPLATE_CHAPTER : TEMPLATE_EMPTY
    }

    this.handleSubmitForm = this.handleSubmitForm.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    this.setState({ dts: nextProps.currentDts })
  }

  handleSubmitForm (e) {
    e.preventDefault()

    const meta = getMetaTemplate(this.state.template)
    const metaItem = {
      id: v4(),
      dts: parseInt(this.state.dts),
      meta
    }

    this.props.addItem({ metaItem })
    this.setState({ dts: '' })
  }

  handleDtsRollback = (e) => {
    e.stopPropagation()
    this.setState({ dts: this.props.currentDts })
  }

  render () {
    const allowRollback = this.state.dts &&
      this.props.currentDts &&
      (this.state.dts !== this.props.currentDts)

    return (
      <Form onSubmit={this.handleSubmitForm}>
        <Form.Group widths='equal'>
          <Form.Field>
            <Input
              fluid
              placeholder='dts'
              size='tiny'
              value={this.state.dts}
              type='number'
              min='0'
              onChange={(e, data) => { this.setState({ dts: data.value }) }}
            />
          </Form.Field>
          {Boolean(allowRollback) && <Popup
            inverted
            size='mini'
            content='Вернуть текущий dts'
            trigger={
              <Button
                basic
                compact
                icon='undo'
                style={{border: 'none'}}
                onClick={this.handleDtsRollback}
              />
            }
          />}
          <Popup
            trigger={
              <Form.Select
                fluid
                placeholder='Шаблон'
                size='tiny'
                options={options}
                defaultValue={isChaptersMode() ? TEMPLATE_CHAPTER : TEMPLATE_EMPTY}
                disabled={isChaptersMode()}
                onChange={(e, data) => { this.setState({ template: data.value }) }}
              />
            }
            size='tiny'
          >
            <Popup.Header>Выберите шаблон метки</Popup.Header>
            <Popup.Content>
              <i>Пустой</i> - шаблон по умолчанию<br />
              <i>Глава</i> - шаблон для оглавления
            </Popup.Content>
          </Popup>
          <Form.Button
            fluid
            content='Добавить'
            color='orange'
            disabled={!this.state.dts}
          />
        </Form.Group>
      </Form>
    )
  }
}

const { func, number } = PropTypes

MetaAddForm.propTypes = {
  addItem: func.isRequired,
  currentDts: number
}

export default MetaAddForm



// WEBPACK FOOTER //
// ./src/components/MetaAddForm/MetaAddForm.js